const SalaryTypes = ['Wybierz', 'Godzinowa', 'Tygodniowa', 'Miesięczna']

export default SalaryTypes;
